import { Col, Row } from "react-bootstrap";
import { Link } from "react-router";

export default function CategoryPanel50v2({ content, path }: any) {
    return (
        <Col xs={12} md={6}>
            <Row className="rounded-4 m-1 my-2 p-3 shadow border-2 border border-warning warrningGradientYellowToWhiteOdd">
                <Col xs={6}>
                    <h2 className="fs-4 fw-bolder text-dark">{content.categoryName}</h2>
                    <div className="text-black-50 small pb-2">
                        <span className="fw-bolder"> {content.productsQuantity} </span>
                        produktów
                    </div>
                </Col>
                <Col xs={6} className="text-center py-2 align-items-center">
                    <Link to={path} className="btn btn-success mb-2 mb-xxl-0 fw-bold">
                        Zobacz produkty <span className="bi bi-caret-right-fill"></span>
                    </Link>
                </Col>
            </Row >
        </Col >
    )
}